import { GraduationCap, Phone, Mail, Clock, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react'
import logo from '../assets/img/olan-academic-blanco.png'

const Footer = () => {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <footer style={{ backgroundColor: '#0F293E' }}>
      <div className="container-main pb-8">
      {/* <div className="container-main pt-16 pb-8"> */}
        <div style={{display:'none'}} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2">
              {/* <div
                className="flex items-center justify-center rounded-full"
                style={{ width: 36, height: 36, backgroundColor: '#10B981' }}
              >
                <GraduationCap size={20} color="white" strokeWidth={2.5} />
              </div> */}
              <img src={logo} alt="Olan Academic" className="w-auto h-12" />
            </div>
            <p className="mt-4 text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.6)' }}>
              La plataforma educativa líder en COLOMBIA. Transformando instituciones desde 2018.
            </p>
            <div className="mt-6 flex gap-3">
              {[
                { icon: Facebook, label: 'Facebook' },
                { icon: Twitter, label: 'Twitter' },
                { icon: Linkedin, label: 'LinkedIn' },
                { icon: Instagram, label: 'Instagram' },
              ].map(({ icon: Icon, label }) => (
                <button
                  key={label}
                  aria-label={label}
                  className="flex items-center justify-center rounded-full transition-all duration-200 cursor-pointer"
                  style={{
                    width: 40,
                    height: 40,
                    border: '1px solid rgba(255,255,255,0.2)',
                    color: 'rgba(255,255,255,0.6)',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#10B981'
                    e.currentTarget.style.color = '#10B981'
                    e.currentTarget.style.backgroundColor = 'rgba(16,185,129,0.1)'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)'
                    e.currentTarget.style.color = 'rgba(255,255,255,0.6)'
                    e.currentTarget.style.backgroundColor = 'transparent'
                  }}
                >
                  <Icon size={18} />
                </button>
              ))}
            </div>
          </div>

          {/* Servicios */}
          <div>
            <h4 className="font-semibold text-base text-white mb-5">Servicios</h4>
            <ul className="space-y-3">
              {['Módulo Académico', 'Aula Virtual', 'Financiero', 'Implementación', 'Soporte'].map(
                (item) => (
                  <li key={item}>
                    <button
                      onClick={() => scrollTo('modulos')}
                      className="text-sm transition-colors duration-200 cursor-pointer hover:text-[#10B981]"
                      style={{ color: 'rgba(255,255,255,0.6)' }}
                    >
                      {item}
                    </button>
                  </li>
                )
              )}
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="font-semibold text-base text-white mb-5">Contacto</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Phone size={16} color="rgba(255,255,255,0.6)" />
                <span className="text-sm" style={{ color: 'rgba(255,255,255,0.6)' }}>
                  +57 320 620 40 41
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} color="rgba(255,255,255,0.6)" />
                <span className="text-sm" style={{ color: 'rgba(255,255,255,0.6)' }}>
                  comercial@olan.edu.co
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={16} color="rgba(255,255,255,0.6)" className="mt-0.5" />
                <div>
                  <p className="text-sm" style={{ color: 'rgba(255,255,255,0.6)' }}>
                    Lunes - Viernes: 8:00 - 17:00
                  </p>
                  <p className="text-sm" style={{ color: 'rgba(255,255,255,0.6)' }}>
                    Sábados: 8:00 - 13:00
                  </p>
                </div>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-base text-white mb-5">Legal</h4>
            <ul className="space-y-3">
              {['Términos de servicio', 'Política de privacidad', 'Política de cookies'].map(
                (item) => (
                  <li key={item}>
                    <span
                      className="text-sm"
                      style={{ color: 'rgba(255,255,255,0.6)' }}
                    >
                      {item}
                    </span>
                  </li>
                )
              )}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div
          className="pt-8 text-center"
          style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}
        >
          <p className="text-sm" style={{ color: 'rgba(255,255,255,0.8)' }}>
            © 2026 Olan Academic.<br/>
            Powered by <a href="https://contactus.ticservice.org/portal/" target="_blank" rel="noreferrer">GUSTAVO ARIZA ARNEDO</a><br/>
            Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
